import { getAPIFromDomain } from "../../lib/api";

export interface BulkRescheduleCsv {
  bulkRescheduleCsv: File;
}

export const uploadBulkRescheduleCsv = (data: BulkRescheduleCsv) => {
  const { bulkRescheduleCsv } = data;
  const api = getAPIFromDomain("logistics");
  const url = `/async/batch_appointment_reschedules`;
  const formData = new FormData();
  formData.set("csv", bulkRescheduleCsv);
  return api.post(url, formData);
};

export const downloadBulkRescheduleCsvTemplate = () => {
  const api = getAPIFromDomain("logistics");
  const url = `/csv_templates/batch_appointment_reschedule`;
  return api.get(url, {
    responseType: "blob",
  });
};
